define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DefaultTelemetryService = /** @class */ (function () {
        function DefaultTelemetryService() {
        }
        DefaultTelemetryService.prototype.markTimeToInteractive = function (scenarioName, additionalProperties) {
            console.log("Scenario ready for interaction " + scenarioName + ", properties:" + JSON.stringify(additionalProperties || {}));
        };
        DefaultTelemetryService.prototype.onClickTelemetry = function (source, additionalProperties) {
            console.log("Item clicked  " + source + ", properties:" + JSON.stringify(additionalProperties || {}));
        };
        DefaultTelemetryService.prototype.scenarioStart = function (scenarioName, additionalProperties) {
            console.log("Scenario started " + scenarioName + ", properties:" + JSON.stringify(additionalProperties || {}));
        };
        DefaultTelemetryService.prototype.scenarioEnd = function (scenarioName, additionalProperties) {
            console.log("Scenario completed " + scenarioName + ", properties:" + JSON.stringify(additionalProperties || {}));
        };
        return DefaultTelemetryService;
    }());
    var KubeFactory = /** @class */ (function () {
        function KubeFactory() {
        }
        KubeFactory.setImageLocation = function (imageLocation) {
            KubeFactory._imageLocation = imageLocation;
        };
        KubeFactory.getImageLocation = function (image) {
            return KubeFactory._imageLocation ? KubeFactory._imageLocation(image) : "";
        };
        KubeFactory.setTelemetryService = function (telemetryService) {
            if (telemetryService) {
                KubeFactory._telemetryService = telemetryService;
            }
        };
        KubeFactory.getTelemetryService = function () {
            if (!KubeFactory._telemetryService) {
                KubeFactory._telemetryService = new DefaultTelemetryService();
            }
            return KubeFactory._telemetryService;
        };
        KubeFactory.setImageService = function (imageService) {
            KubeFactory._imageService = imageService;
        };
        KubeFactory.getImageService = function () {
            return KubeFactory._imageService;
        };
        KubeFactory.setKubeService = function (kubeService) {
            KubeFactory._kubeService = kubeService;
        };
        KubeFactory.getKubeService = function () {
            return KubeFactory._kubeService;
        };
        KubeFactory.markTTI = function (scenarioName, additionalProperties) {
            getTelemetryService().markTimeToInteractive(scenarioName, additionalProperties);
        };
        return KubeFactory;
    }());
    exports.KubeFactory = KubeFactory;
    function getTelemetryService() {
        return KubeFactory.getTelemetryService();
    }
    exports.getTelemetryService = getTelemetryService;
});
